<form [formGroup]="translationForm">
  <div class="header-section-container">
    <app-recipes-translation-header
      [translationLangs]="{
        source: sourceData.lang,
        target: targetData.lang
      }"
      [formTitle]="translationForm.value.target?.titles?.title ?? ''"
      [recipe]="translatedVariantsData.translatedVariants.targetRecipes[0]"
      (translationApproved)="onTranslationApproved($event)"
      [buttonsDisabled]="!isFormValid()"
    />
  </div>

  <div class="form-sections-container">
    <app-recipes-translation-titles-section
      [lang]="{
        source: sourceData.lang,
        target: targetData.lang
      }"
      [domain]="targetData.domain"
      [sourceTitlesFg]="translationForm.controls['source'].controls['titles']"
      [targetTitlesFg]="translationForm.controls['target'].controls['titles']"
    />

    <app-recipes-translation-ingredients
      [source]="variants.source"
      [target]="variants.target"
      [tradLang]="{
        source: sourceData.lang,
        target: targetData.lang
      }"
      [lang]="targetData.lang"
      [market]="targetData.market"
    />

    <app-recipes-translation-steps
      [stepsInfos]="{
          source: {
            variants: variants.source,
            domain: sourceData.domain,
            market: sourceData.market,
            lang: sourceData.lang,
          },
          target: {
            variants: variants.target,
            domain: targetData.domain,
            market: targetData.market,
            lang: targetData.lang,
          },
          sourceSteps: translatedVariantsData.translatedVariants.sourceRecipes[0].steps,
          stepTypes: translatedVariantsData.stepTypes
        }"
    />

    <app-recipes-translation-tips
      [lang]="{
        source: sourceData.lang,
        target: targetData.lang
      }"
      [sourceTipsControl]="translationForm.controls['source'].controls['tips']"
      [targetTipsControl]="translationForm.controls['target'].controls['tips']"
    />
  </div>
</form>
